var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agency-view" },
    [
      _c(
        "div",
        { staticClass: "agency-view__header" },
        [
          _c("order-progress", { attrs: { step: 2 } }),
          _vm._v(" "),
          _c("hotel-block-header", {
            class: {
              "hotel-block-header--agency": true,
              "hotel-block--loading": _vm.hotelLoading
            },
            attrs: { agency: true, hotel: _vm.hotel },
            on: { goback: _vm.goBack }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.mobileActive
        ? _c(
            "div",
            { staticClass: "agency-view__sub-header" },
            [
              _c("image-modal", {
                attrs: { images: _vm.imageList },
                on: { showimage: _vm.onOpenImageModal }
              }),
              _vm._v(" "),
              _vm.showRoomImagesCode
                ? _c("simple-image-modal", {
                    attrs: { images: _vm.roomImageList },
                    on: {
                      close: function($event) {
                        _vm.showRoomImagesCode = false
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "tab-switcher" }, [
                _c(
                  "div",
                  { staticClass: "tab-switcher__nav" },
                  _vm._l(_vm.tabList, function(tab, tabKey) {
                    return _c("button", {
                      key: tabKey,
                      staticClass: "tab-switcher__nav__item",
                      class: { current: _vm.currentTab == tabKey },
                      domProps: { textContent: _vm._s(tab) },
                      on: {
                        click: function($event) {
                          _vm.currentTab = tabKey
                        }
                      }
                    })
                  })
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "agency-view__body" },
        [
          _c(
            "transition-group",
            {
              class: {
                "list-transition--next": _vm.tabDirection > 0,
                "list-transition--prev": _vm.tabDirection < 0
              },
              attrs: { name: "list-transition" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 0 || !_vm.mobileActive,
                      expression: "currentTab == 0 || !mobileActive"
                    }
                  ],
                  key: 0,
                  staticClass: "agency-grid",
                  class: { "agency-grid--loading": _vm.loading }
                },
                [
                  !_vm.loading && _vm.verifiedOfferList.length <= 0
                    ? _c("div", { staticClass: "msg-block msg-block--error" }, [
                        _c("p", [
                          _c("b", [_vm._v(_vm._s(_vm.translations.no_offers))]),
                          _vm._v(" "),
                          _c("a", {
                            attrs: { href: "javascript:void(0)" },
                            domProps: {
                              textContent: _vm._s(
                                _vm.translations.no_offers_ctr
                              )
                            },
                            on: { click: _vm.goBack }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.verifiedOfferList, function(offer, offerKey) {
                    return _c("agency-block", {
                      key: offerKey,
                      attrs: {
                        offer: offer,
                        availbleRoomImageCodes: _vm.availbleRoomImageCodes,
                        "booking-loading": _vm.loadingBookingPage
                      },
                      on: {
                        loadingbooking: function(loadingStatus) {
                          return (_vm.loadingBookingPage = loadingStatus)
                        },
                        showRoomImages: function(code) {
                          return (_vm.showRoomImagesCode = code)
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _vm.verifiedOfferList.length && _vm.hasMoreOffers
                    ? _c("button", {
                        staticClass: "btn btn--load-more",
                        class: { loading: _vm.loading },
                        attrs: { disabled: _vm.loading },
                        domProps: {
                          textContent: _vm._s(_vm.translations.load_more_offers)
                        },
                        on: { click: _vm.veryfyNextOfferChunk }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade-transition" } },
                    [
                      _vm.loading && !_vm.verifiedOfferList.length
                        ? _c("plane-loading", {
                            attrs: { text: _vm.translations.loading_offers }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 1 || !_vm.mobileActive,
                      expression: "currentTab == 1 || !mobileActive"
                    }
                  ],
                  key: 1,
                  staticClass: "agency-view__info",
                  class: { "agency-view__info--loading": _vm.hotelLoading }
                },
                [
                  _vm.hotel.images && !_vm.mobileActive
                    ? _c("image-modal", {
                        attrs: {
                          images: _vm.imageList,
                          videos: _vm.hotel.heliVideos
                        },
                        on: { showimage: _vm.onOpenImageModal }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showRoomImagesCode && !_vm.mobileActive
                    ? _c("simple-image-modal", {
                        attrs: { images: _vm.roomImageList },
                        on: {
                          close: function($event) {
                            _vm.showRoomImagesCode = false
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hotel.heliVideos || _vm.hotel.hasMap
                    ? _c(
                        "div",
                        { staticClass: "info-block info-block__buttons" },
                        [
                          _vm.hotel.hasMap
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-with-icon",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      _vm.showMapModal = true
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "btn__icon btn__icon btn__icon--left",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 19.86 32"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M9.93,6.62a3.31,3.31,0,1,0,3.31,3.31A3.31,3.31,0,0,0,9.93,6.62Zm0,8.83a5.52,5.52,0,1,1,5.52-5.52A5.52,5.52,0,0,1,9.93,15.45ZM9.93,0A9.89,9.89,0,0,0,0,9.85c0,5.73,5.33,8.76,9.39,17.39a.59.59,0,0,0,1.08,0c4.06-8.63,9.39-11.66,9.39-17.39A9.89,9.89,0,0,0,9.93,0Zm8.83,27.59c0,2.43-4,4.41-8.83,4.41S1.1,30,1.1,27.59c0-1.57,1.64-2.95,4.11-3.73.29.48.58.95.85,1.44-1.66.45-2.75,1.18-2.75,2,0,1.37,3,2.48,6.62,2.48s6.62-1.11,6.62-2.48c0-.83-1.09-1.56-2.75-2,.27-.49.56-1,.85-1.44C17.12,24.64,18.76,26,18.76,27.59Z"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "btn__text",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.translations.show_on_map
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hotel.loaded
                    ? _c(
                        "div",
                        { staticClass: "info-block info-block--flex" },
                        [
                          _c("div", { staticClass: "info-block__text" }, [
                            _c("h3", {
                              domProps: {
                                textContent: _vm._s(_vm.translations.location)
                              }
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.hotel.location) +
                                  ", " +
                                  _vm._s(_vm.hotel.region)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.destination && _vm.destination.airTemperature
                            ? _c("div", { staticClass: "info-block__temp" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.destination.airTemperature) +
                                      "°C"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: require("./../../img/icons/icon-temp-sun.svg"),
                                    alt: ""
                                  }
                                })
                              ])
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hotel.description
                    ? _vm._l(_vm.hotel.description, function(
                        hotelDescription,
                        hoteldescriptionKey
                      ) {
                        return _c(
                          "div",
                          {
                            key: "hotel_description_" + hoteldescriptionKey,
                            staticClass: "info-block"
                          },
                          [
                            _c("div", { staticClass: "info-block__text" }, [
                              _c("h3", {
                                domProps: {
                                  textContent: _vm._s(
                                    hotelDescription.title.text
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("p", {
                                domProps: {
                                  textContent: _vm._s(
                                    hotelDescription.paragraph.text
                                  )
                                }
                              })
                            ])
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hotel.facts && _vm.hotel.facts.length
                    ? _vm._l(_vm.factList, function(factItem, factItemKey) {
                        return _c(
                          "div",
                          { key: factItemKey, staticClass: "info-block" },
                          [
                            _c(
                              "div",
                              { staticClass: "info-block__text" },
                              [
                                _c("h3", {
                                  domProps: {
                                    textContent: _vm._s(factItem.name)
                                  }
                                }),
                                _vm._v(" "),
                                factItem.code !== "facilities"
                                  ? _vm._l(factItem.attributes, function(
                                      factAtribute,
                                      factAtributeKey
                                    ) {
                                      return _c("p", { key: factAtributeKey }, [
                                        _vm._v(
                                          _vm._s(factAtribute.name) +
                                            ": " +
                                            _vm._s(factAtribute.value)
                                        )
                                      ])
                                    })
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            factItem.code === "facilities"
                              ? _c(
                                  "div",
                                  { staticClass: "info-block__facilities" },
                                  _vm._l(factItem.attributes, function(
                                    factAtribute,
                                    factAtributeKey
                                  ) {
                                    return _c("span", {
                                      key: factAtributeKey,
                                      staticClass:
                                        "info-block__facilities__item",
                                      domProps: {
                                        textContent: _vm._s(factAtribute.name)
                                      }
                                    })
                                  })
                                )
                              : _vm._e()
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-block" }, [
                    _c(
                      "a",
                      {
                        staticClass: "rejsegarantiordning-btn",
                        attrs: {
                          href: "https://www.skovrejser.dk/rejsegarantiordning",
                          target: "_blank"
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "rejsegarantiordning-btn__icon",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 521.39 521.39"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "m260.69,346.03c12.22,0,29.41-33.05,31.57-85.33h-63.15c2.16,52.29,19.35,85.33,31.57,85.33Z"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "m165.77,239.36h41.81c1.18-29.06,7.18-57.95,17.6-78.34-32.17,12.88-55.39,42.68-59.41,78.34Z"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "m296.21,161.02c10.42,20.39,16.42,49.29,17.6,78.34h41.81c-4.01-35.66-27.24-65.46-59.41-78.34Z"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "m260.69,154.03c-12.22,0-29.41,33.05-31.57,85.33h63.15c-2.16-52.29-19.35-85.33-31.57-85.33Z"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "m165.77,260.69c4.01,35.66,27.24,65.46,59.41,78.34-10.42-20.39-16.42-49.29-17.6-78.34h-41.81Z"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "m410.03,68.69h-21.33v-22.07c0-26.64-25.12-47.46-52.2-40.62l-227.57,62.93c-22.38,1.29-40.23,19.72-40.23,42.42v362.67c0,23.53,19.14,42.67,42.67,42.67h298.67c23.53,0,42.67-19.14,42.67-42.67V111.36c0-23.53-19.14-42.67-42.67-42.67Zm-68.05-42.07c12.45-3.18,25.39,6.91,25.39,20v22.07h-177.5l152.12-42.07Zm-27.95,426.07h-117.33c-5.9,0-10.67-4.77-10.67-10.67s4.77-10.67,10.67-10.67h117.33c5.9,0,10.67,4.77,10.67,10.67s-4.77,10.67-10.67,10.67Zm42.67-42.66h-202.67c-5.9,0-10.67-4.77-10.67-10.67s4.77-10.67,10.67-10.67h202.67c5.9,0,10.67,4.77,10.67,10.67s-4.77,10.67-10.67,10.67Zm-96-42.68c-64.7,0-117.33-52.64-117.33-117.33s52.64-117.33,117.33-117.33,117.33,52.63,117.33,117.33-52.64,117.33-117.33,117.33Z"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "m296.21,339.04c32.17-12.88,55.39-42.68,59.41-78.34h-41.81c-1.18,29.06-7.18,57.95-17.6,78.34Z"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "rejsegarantiordning-btn__text" },
                          [
                            _c("span", [_vm._v("Du er beskyttet af")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Rejsegarantiordningen")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "rejsegarantiordning-btn__arrow",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 27.01 26.01"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M26.13,10.88l-10-10a3,3,0,1,0-4.25,4.24L16.76,10H3a3,3,0,0,0,0,6H16.76l-4.88,4.88a3,3,0,0,0,4.25,4.25l10-10A3,3,0,0,0,27,13,3,3,0,0,0,26.13,10.88Z"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 2,
                      expression: "currentTab == 2"
                    }
                  ],
                  key: 2,
                  staticClass: "agency-view__map"
                },
                [
                  _vm.currentTab == 2
                    ? _c("hotel-map", { attrs: { hotel: _vm.hotelData } })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.mobileActive && _vm.showMapModal
        ? _c(
            "modal",
            {
              staticClass: "modal-view--bg",
              attrs: {
                title: _vm.translations.show_on_map,
                "close-on-click": true,
                "is-open": _vm.mapModalIsOpen
              },
              on: {
                close: function($event) {
                  _vm.showMapModal = false
                }
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "btn__icon btn__icon btn__icon--left",
                  attrs: {
                    slot: "icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 19.86 32"
                  },
                  slot: "icon"
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M9.93,6.62a3.31,3.31,0,1,0,3.31,3.31A3.31,3.31,0,0,0,9.93,6.62Zm0,8.83a5.52,5.52,0,1,1,5.52-5.52A5.52,5.52,0,0,1,9.93,15.45ZM9.93,0A9.89,9.89,0,0,0,0,9.85c0,5.73,5.33,8.76,9.39,17.39a.59.59,0,0,0,1.08,0c4.06-8.63,9.39-11.66,9.39-17.39A9.89,9.89,0,0,0,9.93,0Zm8.83,27.59c0,2.43-4,4.41-8.83,4.41S1.1,30,1.1,27.59c0-1.57,1.64-2.95,4.11-3.73.29.48.58.95.85,1.44-1.66.45-2.75,1.18-2.75,2,0,1.37,3,2.48,6.62,2.48s6.62-1.11,6.62-2.48c0-.83-1.09-1.56-2.75-2,.27-.49.56-1,.85-1.44C17.12,24.64,18.76,26,18.76,27.59Z"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("hotel-map", {
                staticClass: "hotel-map--modal",
                attrs: { hotel: _vm.hotelData }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06bd9640", { render: render, staticRenderFns: staticRenderFns })
  }
}